import { FilterResult } from '../../components/odata-filter/models/filter-result';
import { IEvaluationQueryModel } from './evaluationQueryModel';

export class EvaluationFilterResult implements FilterResult {
  public count: number;
  public values: IEvaluationQueryModel[] = [];
  public nextLink: string;

  public parse(response: any) {
    let result = new EvaluationFilterResult();
    result.count = response['@odata.count'];
    result.values = response.value;
    result.nextLink = response['@odata.nextLink'];
    return result;
  }
}
